/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */

import { Action, Store } from 'fierry/flux';


const State =
{
  online: window.navigator.onLine,

  width: document.documentElement.clientWidth,
  height: document.documentElement.clientHeight,
};


const Actions =
{
  Resize:    new Action(),
  Online:    new Action(),
};


const setSize = (state, { width, height }) =>
{
  return { ...state, width, height };
};


const setOnline = (state, { online }) =>
{
  return { ...state, online };
}


export default new Store(State, Actions,
[
  [Actions.Resize,     setSize],
  [Actions.Online,     setOnline],
]);
